// Both forms use the same Enterprise action, retry interval and error messages.
export function getRecaptchaToken(): Promise<string> {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  if (!siteKey) return Promise.resolve("bypass_for_development");

  return new Promise<string>((resolve, reject) => {
    const sdkWindow = window;
    const tryExecute = (retries = 0) => {
      if (typeof sdkWindow.grecaptcha !== "undefined" && typeof sdkWindow.grecaptcha.enterprise !== "undefined") {
        sdkWindow.grecaptcha.enterprise.ready(() => {
          sdkWindow.grecaptcha!.enterprise!.execute(siteKey, { action: "submit" })
            .then(resolve)
            .catch(() => reject(new Error("Falha ao gerar token de segurança.")));
        });
      } else if (retries < 10) {
        setTimeout(() => tryExecute(retries + 1), 500);
      } else {
        reject(new Error("O sistema anti-spam não carregou. Recarregue a página e tente novamente."));
      }
    };
    tryExecute();
  });
}
